import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {TimemanagementComponent} from "./timemanagement.component";
import {PresenceManagementComponent} from "./presence-management/presence-management.component";
import {HistoryComponent} from "./presence-management/history/history.component";
import {SummaryComponent} from "./presence-management/summary/summary.component";

const routes: Routes = [{
    path: '',
    component: TimemanagementComponent,
    children: [
        {
            path: "presencemanagement",
            loadChildren: () =>
                import("./presence-management/presence.module").then((m) => m.PresenceModule),
        },
        {
            path: "onleavemanagement",
            loadChildren: () =>
                import("./onleave-management/leave.module").then((m) => m.LeaveModule),
        },
        {
            path: "overtimemanagement",
            loadChildren: () =>
                import("./overtime-management/overtime.module").then((m) => m.OvertimeModule),
        },
        {
            path: "timekeeping",
            loadChildren: () =>
                import("./timekeeping-management/timekeeping.module").then((m) => m.TimekeepingModule),
        },
    ]
}
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class TimeManagementRoutingModule {
}
